import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@material-ui/core/Box';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import RoleService from '../../../services/RoleService/RoleService';
import Module from './Module';

/**
 * @Description This function lets you return Modules component.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function Modules({ role, showAlert, setOpen, fetchRoles }) {
    const { t } = useTranslation();
    const [modules, setModules] = useState([]);
    const [enableAll, setEnableAll] = useState({ checked: false });
    const label = 'CONTENT.MODULE.PERMISSION.';

    useEffect(() => { fetchData().then(r => r); }, []);

    const fetchData = async () => {
        let response = await RoleService.getRoleModules(role.id);
        if (response?.status) { setModules(response.data); }
    }

    const handleEnable = () => { setEnableAll({ checked: true }); }

    const handleUpdate = async () => {
        let module = [], actions = [], moduleStatus = [];
        for (const item of modules) {
            if (item.statusChange) {
                moduleStatus.push(item.statusChange);
            }
            if (item.willBeAdded?.length > 0 || item.willBeDeleted?.length > 0) {
                let temp = { id: item.id, willBeAddedPermissions: [], willBeDeletedPermissions: []};
                if (item.willBeAdded?.length > 0) {
                    temp.willBeAddedPermissions = item.willBeAdded;
                }
                if (item.willBeDeleted?.length > 0) {
                    temp.willBeDeletedPermissions = item.willBeDeleted;
                }
                module.push(temp);
            }
            if (item.libraries?.length > 0) {
                for (const library of item.libraries) {
                    if (library.willBeAdded?.length > 0 || library.willBeDeleted?.length > 0) {
                        let temp = { id: library.id, willBeAddedActions: [], willBeDeletedActions: [] };
                        if (library.willBeAdded?.length > 0) {
                            temp.willBeAddedActions = library.willBeAdded;
                        }
                        if (library.willBeDeleted?.length > 0) {
                            temp.willBeDeletedActions = library.willBeDeleted;
                        }
                        actions.push(temp);
                    }
                }
            }
        }
        if (module.length || actions.length || moduleStatus.length) {
            const res = await RoleService.postActionAndPermission({ id: role.id, modules: module, actions, moduleStatus });
            if (res?.status) {
                setOpen(false);
                fetchRoles();
                showAlert(t(`MESSAGES.ROLE.${res.message}`), res.status);
            } else {
                showAlert(t('GENERAL.NETWORK-ERROR'));
            }
        }
    }

    return (
        <Box>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell><span className="role-info">{t(label + 'PERMISSIONS')}</span></TableCell>
                        <TableCell><button className="role-enable" onClick={handleEnable}>{t(label + 'ENABLE')}</button></TableCell>
                        <TableCell/>
                        <TableCell/>
                        <TableCell><span className="role-info">&nbsp;&nbsp;{t(label + 'VIEW')}</span></TableCell>
                        <TableCell><span className="role-info">{t(label + 'UPDATE')}</span></TableCell>
                        <TableCell><span className="role-info">{t(label + 'DELETE')}</span></TableCell>
                        <TableCell><span className="role-info">{t(label + 'PUBLISH')}</span></TableCell>
                        <TableCell><span className="role-info">{t(label + 'CREATE')}</span></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {modules.map((item, itemI) => (<Module module={item} key={itemI} roleID={role.id} enable={enableAll}/>))}
                </TableBody>
            </Table>
            <button className="role-update" onClick={handleUpdate}>{t('CONTENT.ROLE.UPDATE-ROLE')}</button>
        </Box>
    );
}
export default Modules;
